import { PositiveColors, PrimaryColors } from '@picsart/design-system/foundation/colors';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      width: 'fit-content',
      height: 250,
      minWidth: 250,
      maxWidth: 400,
      backgroundColor: PositiveColors.base.default,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: CornerRadius.r16,
      padding: [Spacings.s12, Spacings.s24],
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      gap: Spacings.s32,
      textAlign: 'center',
    },
    closeIcon: {
      cursor: 'pointer',
      position: 'absolute',
      top: Spacings.s12,
      right: Spacings.s12,
    },
    errorIcon: {
      width: 60,
      height: 60,
    },
    description: {
      '& > a': {
        color: PrimaryColors.base.default,
      },
    },
  }),
  {
    name: 'redeem-error-modal',
  },
);

export default useStyles;
